import React, { useState, useEffect, useCallback } from 'react';
import styled from "styled-components";

import { useInterest } from "../hooks/useInterest";

// comps
import Hero from "../components/Hero";
import About from "../components/About";
import Work from "../components/Work";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import TailorModal from "../components/TailorModal";


const Wrapper = styled.div`
    width: 100%;
    height: 100%;
`;

const Content = styled.div`
    font-family: var(--fontBody);
`;




function Home() {

    const { interest, setInterest, hasChosen } = useInterest();
    const [showingTailorModal, setShowingTailorModal] = useState(false);

    // First visit only: offer to tailor the page shortly after it loads.
    useEffect(() => {
        if (hasChosen) return;

        const timeout = setTimeout(() => {
            setShowingTailorModal(true);
        }, 1000);

        return () => {
            clearTimeout(timeout);
        };
    }, [hasChosen]);

    // Arriving with a hash (ex: nav links on the 404 page) lands before the sections exist, so scroll once mounted.
    useEffect(() => {
        if (!window.location.hash) return;

        const section = document.getElementById(window.location.hash.slice(1));
        if (section) section.scrollIntoView();
    }, []);

    const openTailorModal = useCallback(() => {
        setShowingTailorModal(true);
    }, []);

    // Dismissing without picking anything counts as "just browsing" so the modal doesn't come back.
    const closeTailorModal = useCallback(() => {
        setShowingTailorModal(false);
        if (!hasChosen) setInterest("all");
    }, [hasChosen, setInterest]);

    const selectInterest = (value) => {
        setInterest(value);
        setShowingTailorModal(false);
    };

    return (
        <>
            <Wrapper>
                <Content>
                    {   showingTailorModal &&
                        <TailorModal
                            interest={interest}
                            onSelect={selectInterest}
                            onClose={closeTailorModal}
                        />
                    }
                    <Hero />
                    <About />
                    <Work
                        interest={interest}
                        openTailorModal={openTailorModal}
                    />
                    <Contact />
                    <Footer />
                </Content>
            </Wrapper>
        </>
    );
};

export default Home;
